'use client';

import type { SubCategoriesEntity } from '@eliadmin/core/src/api/slugs/types/slug-detail-types';

import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { CategoryCard } from './category-card';
import { MdKeyboardArrowDown } from 'react-icons/md';
import { useState } from 'react';

export function SubcategoriesList({ subcategories }: { subcategories: SubCategoriesEntity[] }) {
  const [showMore, setShowMore] = useState<boolean>(false);

  const { t } = useTranslations();

  return (
    <div className="hidden w-full grid-cols-2 gap-5 sm:grid md:grid-cols-3 lg:grid-cols-4 xl:gap-6">
      {showMore
        ? subcategories.map(subcategory => (
            <CategoryCard key={subcategory.slug} category={subcategory as any} detailedStyles />
          ))
        : subcategories
            .slice(0, 12)
            .map(subcategory => (
              <CategoryCard key={subcategory.slug} category={subcategory as any} detailedStyles />
            ))}
      {subcategories.length > 12 && (
        <div className="col-span-2 flex w-full flex-col items-center justify-center md:col-span-3 lg:col-span-4">
          <span
            onClick={() => setShowMore(!showMore)}
            className="flex cursor-pointer items-center justify-center font-medium tracking-tighter text-primary"
          >
            {showMore ? t('text604') : t('text338')} <MdKeyboardArrowDown size={20} />
          </span>
        </div>
      )}
    </div>
  );
}
